<template>
  <div>
    <div
      v-if="tenderInfo && tenderInfo.tenderId"
      class="tender-check">
      <div class="tender-check__left">
        <div class="tender-check_number">
          {{ `${$t('Tenders.CheckTender')} "#${tenderInfo.tenderNumber}. ${tenderInfo.title}"` }}
        </div>
        <div
          class="tender-check_classification"
          data-qa="item-category">
          {{ tenderInfo && tenderInfo.category ? `${tenderInfo.category.code} ${tenderInfo.category.title}` :'–' }}
        </div>
      </div>
      <div
        class="tender-check__right">
        <CreateTenderDialog
          :disabled="loading.members || loading.additionalFields"
          :loading="loading.members || loading.additionalFields"
          :tender="tender"
          :tender-schedule="tenderInfo.tenderPublishedSchedule"
          :validate-fn="validateFn"/>
      </div>
    </div>
    <TenderItemTabs
      ref="tabs"
      in_creating
      new-flou
      only-view
      :tender="tenderInfo"
      :update-members-count="updateMembersCount"
      @returnToStep="(stepName) => $emit('backStep', stepName)"/>
  </div>
</template>
<script>
import TenderItemTabs from 'components/tenders/tender page/TenderItemTabs.vue'
import CreateTenderDialog from 'components/tenders/dialogs/CreateTenderDialog.vue'

import editTenderMixin from 'mixins/editTenderMixin.js'
import functionMixin from 'mixins/functionMixin'

export default {
  name: 'TenderCheck',
  mixins: [editTenderMixin, functionMixin],
  data() {
    return {
      members_count: 0,
      loading: {
        members: true,
        additionalFields: true
      }
    }
  },
  methods: {
    async beforeSendTender() {
      const result = this.$_.cloneDeep(this.tender)

      result?.lots?.forEach(lot => {
        delete lot.additional_fields
      })
      delete result.members
      delete result.membersCount
      this.$emit('update:tender', result)
    },
    updateMembersCount(count) {
      this.members_count = count
      this.loading.members = false
      if (this.tender.membersCount !== count) {
        const result = this.$_.cloneDeep(this.tender)
        result.membersCount = this.members_count
        this.$emit('update:tender', result)
      }
    },
    // tenderInfo (getTender) не містить additional_fields — LotsTab читає їх саме звідти
    // для побудови колонок/значень доп.полів у таблиці лотів на цьому кроці перевірки
    syncAdditionalFieldsToTenderInfo() {
      if (!this.tenderInfo?.tenderId) {
        return
      }
      this.$set(this.tenderInfo, 'additional_fields', this.additionalFieldsFlat)
    }
  },
  computed: {
    validateFn() {
      return this.$parent?.$parent?.validateObject
    },
    additionalFieldsFlat() {
      return [...(this.additionalFieldsTender || []), ...(this.additionalFieldsLots || [])]
    }
  },
  watch: {
    tenderInfo() {
      this.syncAdditionalFieldsToTenderInfo()
    },
    additionalFieldsFlat() {
      this.syncAdditionalFieldsToTenderInfo()
    }
  },
  async created() {
    /*if (!this.tender?.biddingType?.isPublic) {
      await this.mixin_getInvitedParticipants()
    }*/
    if (this.$can('use', 'availableAdditionalFields')) {
      await this.$store.dispatch('setAdditionalFieldsTypes')
      if (this.tender.tenderId) {
        await this.$store.dispatch('editTenderStore/getAdditionalFieldsByEntity', {tenderId: this.tender.tenderId})
        await this.$store.dispatch('editTenderStore/getAdditionalFieldsByBindingConditions', {
          classificationCode: this.tender?.classificationCode,
          biddingTypeId: this.tender?.biddingType?.biddingTypeId,
        })
        await this.mixin_setAdditionalFieldsToLots(this.tender.lots)
        this.loading.additionalFields = false
      }
    } else {
      this.loading.additionalFields = false
    }
    this.mixin_originTender = await this.removeTypename(this.$_.cloneDeep(this.tender))
  },
  components: {
    TenderItemTabs,
    CreateTenderDialog,
  },
  beforeDestroy() {
    this.beforeSendTender()
  },
  props: {
    /**
     * Модель для редактирования. Запрос getEditTender
     */
    tender: {
      type: Object
    },
    /**
     * Модель для отображения. Запрос getTender
     */
    tenderInfo: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
.tender-check {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5px;
  margin-top: 12px;

}
.tender-check__left {
  min-width: 0;
  word-wrap: break-word;
  hyphens: auto;
}
.tender-check__right {
  max-width: fit-content;
  margin-left: auto;
  display: flex;
}
.tender-check {
  &_number {
    text-align: left;
    color: var(--text-color);
    font-size: 32px;
    line-height: 36px;
    font-weight: 600;
  }
  &_classification {
    margin-top: 8px;
    text-align: left;
    color: rgba(var(--text-color-rgba), .5);
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
